/**
 * MEMO(uchida)
 * URLエンコード/デコード時に使用する関数
 *
 * 組み込みのencodeURIComponent/decodeURIComponentを使用すると、
 * 禁則文字が含まれていた場合にランタイムエラーで落ちてしまうため、
 * try~catchで包んだこの関数を使用すること。
 */
export const uriConverter = {
  encode: (keyword: string): string => {
    try {
      return encodeURIComponent(keyword);
    } catch (e) {
      return keyword;
    }
  },
  decode: (keyword: string): string => {
    try {
      return decodeURIComponent(keyword);
    } catch (e) {
      return keyword;
    }
  },
} as const;
